import Chip from "features/components/Chip";
import Tooltip from "features/components/Tooltip";
import { Option, SelectOption } from "features/ui/Select";

import { useAutoFitChips } from "./useAutoFitChips";

interface CustomSelectedValueProps {
  maxShownValues: number;
  values: SelectOption<Option>[];
  setValues: (options: SelectOption<Option>[]) => void;
  fieldName: string;
  getTagProps: (options: { index: number }) => any;
  onClick?: () => void;
}

export const CustomSelectedValue = ({
  maxShownValues,
  values,
  setValues,
  fieldName,
  getTagProps,
  onClick,
}: CustomSelectedValueProps) => {
  const { containerRef, visibleCount, hiddenCount } = useAutoFitChips(
    values.length,
    maxShownValues
  );

  const shownValues = values.slice(0, visibleCount);

  return (
    <div
      ref={containerRef}
      onClick={onClick}
      className="flex flex-row gap-[3px] overflow-hidden flex-nowrap"
    >
      {hiddenCount > 0 && (
        <Chip className="font-bold shrink-0" label={`+${hiddenCount}`} />
      )}
      {shownValues.map((option, index) => {
        const { key: _key, ...chipProps } = getTagProps({ index });

        return (
          <Tooltip title={option.value.toString()} key={option.id}>
            <Chip
              data-chip
              label={option.label || option.value}
              id={`${fieldName}-autocomplete-selected-${index}`}
              data-testid={`${fieldName}-autocomplete-selected-${index}`}
              {...chipProps}
              className="autocomplete-selected-item !max-w-46 shrink-0"
              onDelete={(e: any) => {
                e.preventDefault();
                e.stopPropagation();
                setValues(values.filter(({ id }) => id !== option.id));
              }}
            />
          </Tooltip>
        );
      })}
    </div>
  );
};
